import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  return (
    <Svg width="35" height="35" viewBox="0 0 35 35" fill="none" {...props}>
      <path
        d="M30.625 30.625L24.2813 24.2813M27.7083 16.0417C27.7083 22.485 22.485 27.7083 16.0417 27.7083C9.59834 27.7083 4.375 22.485 4.375 16.0417C4.375 9.59834 9.59834 4.375 16.0417 4.375C22.485 4.375 27.7083 9.59834 27.7083 16.0417Z"
        stroke="#286DFA"
        stroke-width="2.91667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  )
}
